import { MijnRoute } from '../../mijn-navigatie.model';

export const INSURANCES_MAINTENANCE: MijnRoute = {
    path: 'onderhoud',
    navigationEvent: 'toVerzekerenMaintenance',
    regex: /^\/verzekeren-beheren\/onderhoud$/,
    webcomponent: 'mijn-verzekeren-beheer-webcomponent',
    internalPath: '/onderhoud'
};
